import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { useStore } from "vuex";
import {computed} from "vue";
import ButtonGroup from "@/components/UI/ButtonGroup.vue";
import ButtonPrimitive from "@/components/UI/ButtonPrimitive.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShapeSelector',
  setup(__props) {

const store = useStore();
const selectedMenuItem = computed(() => store.getters.selectedMenuItem);
const shapeSelectorButtons = computed(() => store.getters.shapeSelectorButtons);
const activeItemIndex = computed(() => {
	const index = shapeSelectorButtons.value.findIndex( ( item: {
		active: boolean;
	} )=> item.active === true);

	return index === -1 ? 0 : index;
});

function onClick(type: string, reset = false): void {
	updateShape(type === "shapes" ? "" : type);
	updateCurrentMenuItem(type);

	if (reset) {
		resetUpload();
	}
}

function updateShape(shape: string) {
	store.dispatch("updateShape", shape);
	store.dispatch("resetDrillHoles");
	store.commit("updatePresetShape", "");
}

function updateCurrentMenuItem(selectedMenuItem: string) {
	store.commit("updateMenuItem", selectedMenuItem);
	addMenuItemToDataLayer(selectedMenuItem);
}

function addMenuItemToDataLayer(menuItem: string) {
	if (!menuItem || 0 === menuItem.length) return;

	window?.dataLayer?.push({
		event: "measurements_selector",
		eventCategory: "Shapes & Sizes:" + document.title,
		eventAction: "Step 1. Shape Type",
		eventLabel: menuItem,
	});
}

function resetUpload() {
	store.commit("updateDxfDefinition", {
		svgPath: "",
	});

	// Reset the dxf export state, becasuse of switching between dxf and text
	store.commit('setUploadedContent', {result: '', filename: ''} );
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ButtonGroup, {
    "buttons-per-row": 4,
    "total-buttons": shapeSelectorButtons.value.length,
    "selected-item": activeItemIndex.value
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shapeSelectorButtons.value, (item, index) => {
        return (_openBlock(), _createBlock(ButtonPrimitive, {
          key: index,
          "on-click": () => onClick(item.handler, item.reset),
          icon: item.icon,
          text: item.text,
          index: index,
          "is-active": item.selection === selectedMenuItem.value
        }, null, 8, ["on-click", "icon", "text", "index", "is-active"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["total-buttons", "selected-item"]))
}
}

})